export const GetResourcePutData = (formElements, element) => {
  try {

      var availability = { 
          sun: { startTime:0, endTime:0 },
          mon: { startTime:0, endTime:0 },
          tue: { startTime:0, endTime:0 },
          wed: { startTime:0, endTime:0 },
          thu: { startTime:0, endTime:0 },
          fri: { startTime:0, endTime:0 },
          sat: { startTime:0, endTime:0 },
      };
      
      if (element.options.allocations) {
          availability = { 
              sun: { startTime:0, endTime:2400 },
              mon: { startTime:0, endTime:2400 },
              tue: { startTime:0, endTime:2400 },
              wed: { startTime:0, endTime:2400 },
              thu: { startTime:0, endTime:2400 },
              fri: { startTime:0, endTime:2400 },
              sat: { startTime:0, endTime:2400 },
          };

      }

      var putData = { 
        address: {}, 
        contact: {}, 
        availability, 
        options: {}, 
        customFields: {},
        recurringAvailability: element.options.allocations ? false : true
    };

      for (var i = 0; i < formElements.length; i++) {
          var e = formElements[i];
          switch(e.dataset.post) {
              case undefined:
                  // ignore fields without a data-post entry
                  break;
              case "root":
                  putData[e.name] = e.value

                  if (e.name == "groupId")
                      putData[e.name] = e.value == 0 ? "" : e.value;

                  if (e.name === "timezoneName")
                      putData.timezoneId = e.value

                  break;
              case "address":
                  putData.address[e.name] = e.value;
                  break;
            //   case "timezoneName":
            //     console.log(e.name, e.value)
            //       putData.timezoneId = e.value;
            //       break;
              case "contact":
                  if (e.name == "businessPhone" || e.name == "mobilePhone" || e.name == "homePhone") {
                      putData.contact[e.name] = OnSchedHelpers.ParsePhoneNumber(e.value);
                  }
                  else {
                      console.log("putData.contact["+ e.name + "]");
                      putData.contact[e.name] = e.value;
                  }        
                  break;
              case "options":
                  if (e.name === 'calendarAvailability') {
                      putData.options[e.name] = e.value;
                      let calId = Array.from(formElements).filter(formEl => formEl.id === 'externalCalendarId')[0].value;

                      if (calId) {
                        // Set to Google if Calendar Availability is 1
                        if (parseInt(e.value) === 1) putData.options['googleCalendarId'] = calId;
                        // Set to Outlook if Calendar Availability is 2
                        if (parseInt(e.value) === 2) putData.options['outlookCalendarId'] = calId;
                      }
                  }
                  break;
              case "businessHours":
                  var bhDay = e.dataset.day;
                  var bhTime = e.name.substr(3);
                  
                  const updateStartEnd = (start, end) => {
                    if (bhTime.includes("Start"))
                        putData.availability[bhDay].startTime = start;
                    else
                        putData.availability[bhDay].endTime = end;
                  }

                  if (e.dataset.isopen === 'false') {
                    updateStartEnd(0, 0);
                  }
                  else if (e.dataset.is24hours === 'true') {
                    updateStartEnd(0, 2400)
                  }
                  else {
                    updateStartEnd(e.value, e.value)
                  }
                    
                  break;
              case "customFields":
                  putData.customFields[e.name] = e.value;
                  break;
              default:
                  console.log(e.dataset.post + " " + e.name + " unrecognizable put attribute");
                  break;
          }
      }
      return putData;
  } catch (e) {
      // TODO - raise error event to the app client
      console.log("GetResourcePutData failed");
      console.log(e);
  }
}
